import { FolkGraph } from '../folk-graph';
FolkGraph.define();
export { FolkGraph };
//# sourceMappingURL=folk-graph.js.map